/**
 * Redirect to Sale page searchUrl (search page result)
 * @param {string} searchUrl
 */
function redirectToSaleSearch (searchUrl) {

	const adjustedSearchUrl = searchUrl.replace('#', '');
	const searchPartialUrl = `/s/sales_on-sale/${adjustedSearchUrl}?s=1`;

	// redirect to search result page
	window.location.href = searchPartialUrl;

}

export default redirectToSaleSearch;
